import { TokenEnum } from "../../shared/constants/user_constants"

export const clearAuthFromLocalStorage = () => {
    localStorage.removeItem(TokenEnum.ACCESS_TOKEN)
    localStorage.removeItem(TokenEnum.ID_TOKEN)
}